module.exports = "<div class=\"ui-card ui-card-hover padding-md\"\r\n    ng-click=\"$ctrl.desplegar = true\">\r\n  <div class=\"kd-item kd-item--large\">\r\n    <div class=\"flex\">\r\n      <div class=\"text-bold\">Un reembolso</div>\r\n      <div>Ya se ha realizado el viaje y se adjuntarán comprobantes de gastos realizados para la justificación del reembolso.</div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<viaticos-shared-reembolso-dialogo\r\n    on-close=\"$ctrl.getAccion($event.detail)\"\r\n    ng-if=\"$ctrl.desplegar\"></viaticos-shared-reembolso-dialogo>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/viaticos/components/shared/reembolso/template.html
// module id = 3376
// module chunks = 0